import { CSSObject } from "@emotion/react";
import { CheckboxStyleOverrides } from "@newsela/angelou";

export const checkboxCss: CheckboxStyleOverrides<CSSObject> = {
  root: {
    padding: "4px",
  },

  labelText: {
    display: "flex",
    flexDirection: "row-reverse",
    marginLeft: "-5px",

    svg: {
      width: "24px",
      marginRight: "4px",
    },
  },
};
